
    import { defineComponent } from 'vue';
    import { useResultsStore } from '../../stores/citation-search-results';
    import { useUserStore } from './../../stores/user';
    import { Form, Field } from "vee-validate";
    import * as yup from "yup";
    import currency from 'currency.js';


    export default defineComponent({
        components: {
            Form,
            Field,
        },
        data() {
            var results = useResultsStore();
            var minCalc = (results.Overview.PartialPaymentInstallmentDate == null || results.Overview.PartialPaymentInstallmentDate == "") ? (results.Overview.FullPaymentAmountDue || 0) : (results.Overview.PartialFeeFineContemptPaymentAmountDue || 0) + (results.Overview.PartialProbationPaymentAmountDue || 0);

            const schema = yup.object().shape({
                AmountToPay: yup.string()
                    .required('Amount To Pay is required')
                    .test('amount-to-pay-min', 'Payment must be at least ' + ((results.Overview.PartialPaymentInstallmentDate == null || results.Overview.PartialPaymentInstallmentDate == "") || minCalc == 0 || minCalc >= (results.Overview.FullPaymentAmountDue || 0)
                        ? currency((results.Overview.FullPaymentAmountDue || 0)).format()
                        : currency((results.Overview.PartialFeeFineContemptPaymentAmountDue || 0) + (results.Overview.PartialProbationPaymentAmountDue || 0)).format()),
                        (value) => currency(value || '0').value >= ((results.Overview.PartialPaymentInstallmentDate == null || results.Overview.PartialPaymentInstallmentDate == "") || minCalc == 0 || minCalc >= (results.Overview.FullPaymentAmountDue || 0)
                            ? (results.Overview.FullPaymentAmountDue || 0)
                            : ((results.Overview.PartialFeeFineContemptPaymentAmountDue || 0) + (results.Overview.PartialProbationPaymentAmountDue || 0)))
                    )
                    .test('amount-to-pay-max', 'Payment must be equal or less than ' + currency((results.Overview.AmountDue || 0)).format(), (value) => currency(value || '0').value <= (results.Overview.AmountDue || 0))

            });
            return {
                schema,
                results,
                userStore: useUserStore(),
                AmountToPay: "",
                masks: {
                    moneyMask: "0,99",
                    //eslint-disable-next-line
                    moneyToken: "0:\d:multiple|9:\d:optional",
                },
                paymentType: 'full',
                showPartialConfirmation: false,
                partialPaymentConfirmed: false,
            }
        },
        computed: {
            personsName(): string {
                return `${(this.results.Overview.LastNameFromSearch || '')}, ${(this.results.Overview.FirstNameFromSearch || '')} ${(this.results.Overview.MI || '')}`
            },
            attachmentList(): string {
                return this.results.Attachments.map(x => x.AttachmentRecId).join(", ");
            },
            minPayment(): number {
                return (this.results.Overview.PartialPaymentInstallmentDate == null || this.results.Overview.PartialPaymentInstallmentDate == "") ? (this.results.Overview.FullPaymentAmountDue || 0) : (this.results.Overview.PartialFeeFineContemptPaymentAmountDue || 0) + (this.results.Overview.PartialProbationPaymentAmountDue || 0);
            },
            disablePartialPayments(): boolean {
                return this.results.Overview.PartialPaymentInstallmentDate == null || this.results.Overview.PartialPaymentInstallmentDate == "" || this.results.Overview.PartialPaymentInstallmentVerbiage == null || this.results.Overview.PartialPaymentInstallmentVerbiage == "";
            },
            displayCourtName(): string {
                if (this.results.Overview.Court == 'F') {
                    return '1st Parish Court';
                } else if (this.results.Overview.Court == 'S') {
                    return '2nd Parish Court';
                }
                return '';
            }
        },
        methods: {
            paybill() {
                //set amount to user will pay to the store.
                this.results.setAmountUserWillPay(currency(this.AmountToPay).value);

                if (+this.AmountToPay == this.results.Overview.FullPaymentAmountDue) {
                    if (this.userStore.user != null && Object.keys(this.userStore.user).length > 0) {
                        this.$router.push({ name: 'paymentInfo' })
                    } else {
                        this.$router.push({ name: 'paymentLoginCheck' })
                    }
                } else {
                    this.showPartialConfirmation = true;
                }
            },
            setAmount(type: string): void {
                if (type == "full") {
                    this.AmountToPay = currency((this.results.Overview.FullPaymentAmountDue || 0), { separator: '', symbol: '' }).format();
                } else if (type == "min") {
                    this.AmountToPay = currency(this.minPayment, { separator: '', symbol: '' }).format()
                } else if (type == "other") {
                    this.AmountToPay = currency(this.minPayment, { separator: '', symbol: '' }).format()
                }
            },
            confirmPartialPaymentVerbiage() {
                if (this.partialPaymentConfirmed) {
                    if (this.userStore.user != null && Object.keys(this.userStore.user).length > 0) {
                        this.$router.push({ name: 'paymentInfo' })
                    } else {
                        this.$router.push({ name: 'paymentLoginCheck' })
                    }
                }
            },
        },
        created() {
            //set amount to pay = to min payment
            this.AmountToPay = currency((this.results.Overview.FullPaymentAmountDue || 0), { separator: '', symbol: '' }).format();
        },
    });
